export default "__VITE_ASSET__Cnc7zFAw__"